import React, { useCallback } from 'react';

import { Button } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';
import type { Seo } from '@sravni/types/lib/seo';

import type * as Microcredits from '@src/@types/microcredits';
import { DESKTOP_BUTTON_SIZE, FILTER_INPUT_LABEL, MOBILE_BUTTON_SIZE } from '@src/components/PageHeader/consts';
import { AmountControl } from '@src/components/ui/AmountControlAB';
import { usePageContext } from '@src/config/PageContext';
import { PRODUCT_LIST_ANCHOR } from '@src/constants/common';
import { FILTERS_NAMES, AMOUNT_SETTINGS } from '@src/constants/filters';
import { scrollToElementById } from '@src/helpers/common';
import { useSelectCreditsList } from '@src/reducers/microcredits';

import styles from './styles.module.scss';

interface ISimplePageHeaderFiltersProps {
    className?: string;
    difference?: number;
    filters: Microcredits.IFilters;
    conditionsActive?: boolean;
    onChange: (value: any, name: string) => void;
    onToggleConditionDialog?: () => void;
    seo?: Partial<Seo>;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export const SimplePageHeaderFilters: React.FunctionComponent<ISimplePageHeaderFiltersProps> = React.memo(
    ({ filters, onChange }) => {
        const { listKey } = usePageContext();
        const isMobile = useIsMobile();
        const { total: count = 0 } = useSelectCreditsList(listKey);

        const handleClickSelectionButton = useCallback(() => {
            scrollToElementById(PRODUCT_LIST_ANCHOR);
        }, []);

        return (
            <div className={styles.wrapper}>
                <div className={styles.sumField}>
                    <AmountControl
                        name={FILTERS_NAMES.AMOUNT}
                        className={styles.amount}
                        label={FILTER_INPUT_LABEL}
                        value={filters[FILTERS_NAMES.AMOUNT]}
                        max={AMOUNT_SETTINGS.max}
                        onChange={onChange}
                        postfix="₽"
                    />
                </div>

                <Button
                    variant="primary"
                    size={isMobile ? MOBILE_BUTTON_SIZE : DESKTOP_BUTTON_SIZE}
                    onClick={handleClickSelectionButton}
                    className={styles.button}
                >
                    Показать {count}
                </Button>
            </div>
        );
    },
);
